import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import * as firebase from 'firebase'

Vue.config.productionTip = false

new Vue({
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyCc3drzqNLaeYMk_08goaCanX2cKI9B3Kk',
      authDomain: 'hack-utd-6f3a2.firebaseapp.com',
      databaseURL: 'https://hack-utd-6f3a2.firebaseio.com',
      projectId: 'hack-utd-6f3a2',
      storageBucket: 'hack-utd-6f3a2.appspot.com',
      messagingSenderId: '972368861079'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('setLoading', true)
        this.$store.dispatch('autoSignIn', user)
      }
    })
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
